module.exports = __webpack_public_path__ + "static/media/imgEmojiSkull@2x.ef19ddbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgEmojiSkull@2x.png
// module id = 370
// module chunks = 22